import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const FilterBar = ({ filters, onFilterChange }) => {
  const urgencyOptions = [
    { value: 'all', label: 'All Urgencies' },
    { value: 'Emergency', label: 'Emergency' },
    { value: 'Scheduled', label: 'Scheduled' }
  ];

  const issueTypeOptions = [
    { value: 'all', label: 'All Issue Types' },
    { value: 'Mechanical', label: 'Mechanical' },
    { value: 'Electrical', label: 'Electrical' },
    { value: 'Safety', label: 'Safety' },
    { value: 'Routine Maintenance', label: 'Routine Maintenance' },
    { value: 'Other', label: 'Other' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'pending', label: 'Pending' },
    { value: 'in-progress', label: 'In Progress' },
    { value: 'completed', label: 'Completed' },
    { value: 'cancelled', label: 'Cancelled' }
  ];

  const handleFilterChange = (key, value) => {
    onFilterChange(prev => ({ ...prev, [key]: value }));
  };

  const hasActiveFilters = filters?.urgency !== 'all' || filters?.issueType !== 'all' || filters?.status !== 'all';

  const clearFilters = () => {
    onFilterChange({
      urgency: 'all',
      issueType: 'all',
      status: 'all',
      proximity: 'all'
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 shadow-elevation-1">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} color="var(--color-primary)" strokeWidth={2} />
          <h3 className="text-sm font-semibold text-foreground">Filters</h3>
        </div>
        {hasActiveFilters && (
          <button
            onClick={clearFilters}
            className="text-xs text-primary hover:text-primary/80 font-medium transition-hover"
          >
            Clear All
          </button>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Select
          label="Urgency"
          options={urgencyOptions}
          value={filters?.urgency}
          onChange={(value) => handleFilterChange('urgency', value)}
        />
        <Select
          label="Issue Type"
          options={issueTypeOptions}
          value={filters?.issueType}
          onChange={(value) => handleFilterChange('issueType', value)}
        />
        <Select
          label="Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => handleFilterChange('status', value)}
        />
      </div>
    </div>
  );
};

export default FilterBar;